import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartItems: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
   

addToCart: (state, action) => {
  const item = action.payload;

  const existing = state.cartItems.find(
    (i) => i.id === item.id
  );

  if (existing) {
    existing.quantity += 1;
  } else {
    state.cartItems.push({
      ...item,
      quantity: 1,
    });
  }
},    

increaseQty: (state, action) => {
  const food = action.payload;
  const item = state.cartItems.find((i) => i.id === food.id);

  if (item) {
    item.quantity += 1;
  } else {
    state.cartItems.push({
      ...food,
      quantity: 1,
    });
  }
},
    decreaseQty: (state, action) => {
      const item = state.cartItems.find(i => i.id === action.payload);

      if (item) {
        if (item.quantity > 1) {
          item.quantity -= 1;
        } else {
          // remove if quantity = 1
          state.cartItems = state.cartItems.filter(i => i.id !== action.payload);
        }
      }
    },

    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.id !== action.payload
      );
    },

    clearCart: (state) => {
      state.cartItems = [];
    }
  },
});

export const {
  addToCart,
  increaseQty,
  decreaseQty,
  removeFromCart,
  clearCart
} = cartSlice.actions;

export default cartSlice.reducer;